export const environment = {
  production: true,
  profile: 'dev',

  sandbox_account_logo: '/assets/icons/sandbox_account_logo.svg',

  authentication_host: 'http://dev1-accounts.sandbox.co.in',

  silo_url: 'https://dev-api.silo.quicko.company',
  silo_environment: 'dev',
  api_auth_endpoint: 'https://keq7mx11sf.execute-api.ap-south-1.amazonaws.com/dev/auth',
  console_endpoint: "https://dev-console.sandbox.co.in",

  ic_sbox_brackets: 'assets/icons/ic_sbox_brackets.svg',
  token_issuer: 'https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_hq20ltKE2'

};
